import { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import FilterBar from "components/Common/FilteringBar";
import BackButton from "../../../components/Common/BackButton.js";
import TableListComponent from "../../../components/Common/TableListComponent";
import ModalSubscriberStation from "components/Modals/ModalSubscriberStation";
import ButtonAdd from "components/Common/ButtonAdd.js";

const SubscriberStation = (props) => {
  const [state, setState] = useState({
    pageTitle: "Абонатни станции",
    data: [
      {
        id: "subscriber-staiton1",
        name: "Името на Абонатна станция",
        number: "12A24C",
        isActive: true,
      },
      {
        id: "subscriber-staiton2",
        name: "Името на Абонатна станция 2",
        number: "12A24C",
        isActive: true,
      },
      {
        id: "subscriber-staiton3",
        name: "Името на Абонатна станция 3",
        number: "12A24C",
        isActive: true,
      },
    ],
    isModalOpen: false,
    isActive: true,
  });

  const emitErrors = (error) => {
    props.onErrorsShow(error.body);
  };

  const toggleActive = (id) => {
    const currentState = state.heaters;

    const index = currentState.findIndex((item) => item.id === id);
    currentState[index].isActive = !currentState[index].isActive;

    setState((state) => ({ ...state, heaters: currentState }));
  };

  const deleteItem = (id) => {
    if (window.confirm("Delete selected?")) {
      const currentState = state.heaters;
      const index = currentState.findIndex((item) => item.id === id);
      currentState.splice(index, 1);

      setState((state) => ({ ...state, heaters: currentState }));
    }
  };

  const openModal = () => {
    setState((state) => ({ ...state, isModalOpen: !state.isModalOpen }));
    removeBodyCss();
  };

  const closeModal = () => {
    setState((state) => ({ ...state, isModalOpen: false }));
    removeBodyCss();
  };

  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const handleDataChange = (event) => {
    const value = event.target.value;
    setState((state) => ({
      ...state,
      [event.target.name]: value,
    }));
  };

  const handleNewItemAdd = (item) => {
    const currentState = state.heaters;
    currentState.push(item);

    setState((state) => ({
      ...state,
      heaters: currentState,
      isModalOpen: false,
    }));
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <BackButton className="mb-4" />

              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <CardTitle className="mb-4">{state.pageTitle}</CardTitle>
                    </Col>
                  </Row>

                  <div className="d-flex align-items-start mb-4">
                    <div className="flex-grow-1">
                      <FilterBar
                        tableData={state.data}
                        isActive
                        state={state}
                        setState={setState}
                      ></FilterBar>
                    </div>

                    <ButtonAdd
                      onBtnClick={openModal}
                      data-toggle="modal"
                      tooltip="Добави нова станция"
                    />
                  </div>

                  <TableListComponent
                    tableData={state.data}
                    tableColumns={["Име"]}
                    toggleActive={toggleActive}
                    deleteItem={deleteItem}
                    category={"subscriber-station"}
                    isLoading={state.isLoading}
                    isLoaded={state.isLoaded}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <ModalSubscriberStation
            isModalOpen={state.isModalOpen}
            closeModal={closeModal}
            addNewItem={handleNewItemAdd}
            emitErrors={emitErrors}
          />
        </Container>
      </div>
    </>
  );
};

SubscriberStation.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SubscriberStation));
